// INJECT_FROM_PLOP_TABLELIST
export const STORE_DOCUMENT = 'documentStore'
export const STORE_AUTH = 'authStore'
export const STORE_DASHBOARD = 'dashboardStore'
export const STORE_METADATA = 'metadataStore'
export const STORE_REPORT = 'reportStore'
export const STORE_HELP_CENTER = 'helpCenterStore'
export const STORE_INVOICE = 'invoiceStore'
export const STORE_PROFILE = 'profileStore'
export const STORE_REGISTRATION_DOCUMENT = 'registrationDocumentStore'
export const STORE_SITE_VISIT = 'siteVisitStore'
